import { DTONotificationType } from "./settings";
import { z } from "zod";
export const DTONotificationChatMentionPayload = z.object({
    messageAuthorId: z.string(),
    messageText: z.string(),
    messageId: z.string(),
    parentMessageId: z.string().optional(),
    workspaceId: z.string(),
    projectId: z.string(),
    subjectType: z.string(),
    threadSubjectId: z.string(),
    subjectName: z.string(),
});
export const DTONotificationProjectInvitationPayload = z.object({
    workspaceId: z.string(),
    projectId: z.string(),
    projectTitle: z.string(),
    invitedByUserId: z.string(),
    invitationRole: z.string(),
    featureId: z.string().optional(),
});
export const DTONotificationProjectDocumentCommentPayload = z.object({
    documentId: z.string(),
    entityTitle: z.string(),
    projectId: z.string(),
    workspaceId: z.string(),
    threadId: z.string(),
    commentId: z.string(),
    commentCreatedAt: z.string(),
    commentAuthorId: z.string(),
    commentBody: z.string(),
});
export const DTONotificationBase = z.object({
    userId: z.string(),
    subjectId: z.string(),
    roomId: z.string().optional(),
    workspaceId: z.string(),
});
export const DTONotificationCreateInput = z
    .discriminatedUnion("type", [
    z.object({
        type: z.literal(DTONotificationType.enum.ChatMention),
        activityData: DTONotificationChatMentionPayload,
    }),
    z.object({
        type: z.literal(DTONotificationType.enum.ProjectInvitation),
        activityData: DTONotificationProjectInvitationPayload,
    }),
    z.object({
        type: z.literal(DTONotificationType.enum.ProjectDocumentComment),
        activityData: DTONotificationProjectDocumentCommentPayload,
    }),
])
    .and(DTONotificationBase);
